var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.943,
    height: 19.828,
    viewBox: "0 0 18.943 19.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7 -4.992)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.375,5a.874.874,0,0,0-.241.062L7.544,8.583A.881.881,0,0,0,7,9.4V20.416a.881.881,0,0,0,.544.812l8.59,3.524a.879.879,0,0,0,.674,0l8.59-3.524a.881.881,0,0,0,.544-.812V9.4a.881.881,0,0,0-.544-.819l-8.59-3.524A.879.879,0,0,0,16.375,5Zm.1,1.831L22.735,9.4,16.471,11.97,10.208,9.4ZM8.762,10.717l6.828,2.8v9.1l-6.828-2.8Zm15.419,0v9.1l-6.828,2.8v-9.1l6.828-2.8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.5aa4d608ee2d9bdb20eeed2b77485a37.svg";
export { ForwardRef as ReactComponent };